import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import SideBar from "../../Components/Navbar/Sidebar";
import Switch from "react-switch";
import Modal from "react-modal";
import Pajination from "../../helpingFiles/Pagination/Pajination";
import { toggleButtonVendeors, venders } from "../../Components/Apis/apis";
import Head from "../../Components/ontabletop/head";
import { useLocation, useNavigate } from "react-router-dom";
import NewVendor from "../../Components/vendors/newVendor";
import Loader from "../../Components/loader";

const initialState = {
  name: "",
  code: "",
  contact_email: "",
  contact_phone: "",
  unsynced: "",
  synced: "",
  updated: "",
  status: "",
};
const Odousers = () => {
  const [loading, setLoading] = useState(false);
  const [posts, setPosts] = useState([]);
  const [Vendor, setVendor] = useState(true);
  const [open, setOpen] = useState(false);
  const navigation = useNavigate();
  const [model, setModel] = useState([]);
  const locations = useLocation();
  const path = locations.pathname;
  const [total, setTotal] = useState("");
  const [page, setPage] = useState(1);
  const [postPerpage, setPostPerPage] = useState(10);
  const [query, setQuery] = useState("");
  const [edit, setEdit] = useState(initialState);

  const {
    name,
    code,
    contact_email,
    contact_phone,
    unsynced,
    synced,
    updated,
    status,
  } = edit;

  const fetchPost = async () => {
    setLoading(true);
    const data = await venders();

    if (data.message === "You are not authorized for this page") {
      navigation("/");
    } else {
      setPosts(data);
      setTotal(data.length);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPost();
  }, []);

  const handel = async (id) => {
    const data = await toggleButtonVendeors(path, id);
    if (data.message == "You are not authorized for this Action") {
      alert(data.message);
    } else {
      setPosts(data);
    }
  };
  useEffect(() => {
    setEdit({ ...model });
  }, [model]);

  const headers = [
    { key: "id", label: "SL NO" },
    { key: "name", label: "Name" },
    { key: "busienss", label: "Busienss" },
    { key: "email", label: "Email" },
    { key: "created", label: "Date" },
    { key: "phone", label: "Phone" },
    { key: "unsynced_media", label: "Unsynced_Media" },
    { key: "synced_media", label: "Synced_Media" },
    { key: "invoice_emails", label: "invoice_emails" },
    { key: "updates_media", label: "Updates_Media" },
    // { key: "switch", label: "Status" },
  ];

  // Get Current Posts (Pagination)
  const indexOfLastPage = page * postPerpage;
  const indexOfFirstPage = indexOfLastPage - postPerpage;
  const currentPosts = posts.slice(indexOfFirstPage, indexOfLastPage);

  const ItemChange = async (e) => {
    const { name, value } = e.target;
    setEdit({ ...edit, [name]: value });
  };
  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "numeric", day: "numeric" };
    const formattedDate = new Date(dateString).toLocaleDateString(
      undefined,
      options
    );
    return formattedDate;
  };
  return (
    <div className="containers">
      <div className="container-sidebar">
        <SideBar />
      </div>
      <div className="container-pages">
        {Vendor ? (
          <>
            <div>
              <div className="page-title">
                <button onClick={() => setVendor(false)} className="new-btn d-none">
                  New Vendor
                </button>
              </div>
              <Head setPostPerPage={setPostPerPage} setQuery={setQuery} />

              {loading ? (
                <Loader />
              ) : (
                <>
                  {/* making User tabel */}
                  {currentPosts.length == 0 ? (
                    <h2 className="text-secondary">No Vendors found</h2>
                  ) : (
                    <>
                      <table className="table table-boarder table-hover table-striped table-sm">
                        <thead className="thead-dark">
                          <tr>
                            {headers.map((row) => {
                              return <td key={row.key}>{row.label}</td>;
                            })}
                          </tr>
                        </thead>
                        <tbody>
                          {/* putting data on table by map function */}
                          {currentPosts
                            .filter((obj) => {
                              if (query == "") {
                                return obj;
                              } else if (
                                obj.name
                                  .toLowerCase()
                                  .includes(query.toLowerCase()) ||
                                obj.code
                                  .toLowerCase()
                                  .includes(query.toLowerCase())
                              ) {
                                return obj;
                              }
                            })
                            .map((posts, index) => (
                              <tr key={index}>
                                <td>
                                  {index+1}
                                </td>
                                <td>{posts.name}</td>
                                <td>{posts.code}</td>
                                <td>
                                  {posts.contact_email
                                    ? posts.contact_email
                                    : "No Data"}
                                </td>
                                <td>{formatDate(posts.created)}</td>
                                <td>
                                  {posts.contact_phone
                                    ? posts.contact_phone
                                    : "No Data"}
                                </td>

                                <td>{posts.unsynced}</td>
                                <td>{posts.synced}</td>
                                <td>{posts.status}</td>
                                <td>{posts.updated}</td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                      <Pajination
                setPostPerPage={setPostPerPage}
                postPerpage={postPerpage}
                page={page}
                setPage={setPage}
                total={total}
              />
                    </>
                  )}
                </>
              )}
              {/* View of pagination */}
              <Modal isOpen={open} className="mt-5 h-100 w-75">
                <div className="bg-info d-flex justify-content-between rounded-3">
                  <h5>
                    #{model.id} - {(model.name ??= "any")}
                  </h5>
                </div>
                <div className="d-flex  m-0 justify-content-between">
                  <a href="#profile">
                    <h6>Profile</h6>
                  </a>

                  <a href="#proposal">
                    <button>Proposals</button>
                  </a>

                  <a href="#reminder">
                    <h6>Reminders</h6>
                  </a>
                  <a href="#activity">
                    <h6>Activity Log</h6>
                  </a>
                </div>
                <button
                  className="border-0 bg-info"
                  onClick={(e) => setOpen(!open)}
                >
                  X
                </button>

                <form>
                  <input
                    type="text"
                    name="name"
                    value={name}
                    onChange={ItemChange}
                  />
                  <input
                    type="text"
                    name="code"
                    value={code}
                    onChange={ItemChange}
                  />
                  <input
                    type="text"
                    name="contact_email"
                    value={contact_email}
                    onChange={ItemChange}
                  />
                  <input
                    type="tel"
                    name="contact_phone"
                    value={contact_phone}
                    onChange={ItemChange}
                  />
                  <input
                    type="number"
                    name="status"
                    value={status}
                    onChange={ItemChange}
                  />
                  <input
                    type="number"
                    name="unsynced"
                    value={unsynced}
                    onChange={ItemChange}
                  />
                  <input
                    type="number"
                    name="synced"
                    value={synced}
                    onChange={ItemChange}
                  />
                  <input
                    type="number"
                    name="updated"
                    value={updated}
                    onChange={ItemChange}
                  />
                </form>
              </Modal>
            
            </div>
          </>
        ) : (
          <>
            <NewVendor
              setVendor={setVendor}
              path={path}
              fetchPost={fetchPost}
            />
          </>
        )}
      </div>
    </div>
  );
};
export default Odousers;
